import * as React from "react";

import { isBrowserChromiumBased } from "@/shared/environment/userEnvironment";

const LSKEY_SUGGEST_CHROMIUM_HIDDEN = "Workspace.SUGGEST_CHROMIUM_HIDDEN";
/**
 * We've found that Chromium gives better performance at loading large datasets.
 *
 * Until we can get to the bottom of why, advise users of other browsers what's up
 * if their data loads take a very long time.
 */
export function useSuggestChromium() {
  const [suggestionShown, setSuggestionShown] = React.useState(() => {
    return localStorage.getItem(LSKEY_SUGGEST_CHROMIUM_HIDDEN) === "true";
  });
  const isChromium = isBrowserChromiumBased();

  function hideChromiumSuggestion() {
    setSuggestionShown(true);
    localStorage.setItem(LSKEY_SUGGEST_CHROMIUM_HIDDEN, "true");
  }

  return {
    showChromiumSuggestion: !isChromium && !suggestionShown,
    hideChromiumSuggestion,
  };
}
